module.exports = __webpack_public_path__ + "img/seen.c3fb2616.svg";